<template>
    <div class="row align-items-end">
        <div class="col-md-3 mb-1">
            <label class="form-label">Oluşturulma Tarih Aralığı</label>
            <v-date-picker v-model="date" range placeholder="Tarih Aralığı"></v-date-picker>        
        </div>
        <div class="col-md-3 mb-1">
            <label class="form-label">Tamamlandı</label>
            <select class="form-control" v-model="filter.IsCompleted">
                <option v-for="o in boolData" :value="o.value" :key="o.value">{{ o.text }}</option>
            </select>        
        </div>
        <div class="col-md-3 mb-1">
            <label class="form-label">Ödeme Başarılı</label>
            <select class="form-control" v-model="filter.IsPaymentSuccessfull">
                <option v-for="o in boolData" :value="o.value" :key="o.value">{{ o.text }}</option>
            </select>        
        </div>
        <div class="col-md-3 mb-1">
            <label class="form-label">Netsis Başarılı</label>
            <select class="form-control" v-model="filter.IsNetsisSuccessfull">
                <option v-for="o in boolData" :value="o.value" :key="o.value">{{ o.text }}</option>
            </select>        
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Netsis Özel Hesap Kapatma Başarılı</label>
            <select class="form-control" v-model="filter.IsNetsisOzelHesapKapatmaSuccessfull">
                <option v-for="o in boolData" :value="o.value" :key="o.value">{{ o.text }}</option>
            </select>        
        </div>
        <div class="col-md-3 mb-1 mb-md-0">
            <label class="form-label">Plasiyer</label>
            <v-select-list :options="salesman" label="Visual" v-model="sm" placeholder="Plasiyer"></v-select-list>
        </div>
        <div class="col-auto">
            <button class="btn btn-secondary" v-on:click="$emit('filter',filter)">Filtrele</button>
        </div>
        <div class="col-auto">
            <button class="btn btn-dark" v-on:click="clearForm">Temizle</button>
        </div>
    </div>
</template>

<script>
import { UserApi } from '@/api/user'
export default {
    data(){
        return{
            filter:{
                CreateTimeStart :null,
                CreateTimeEnd :null,
                IsCompleted :null,
                IsNetsisOzelHesapKapatmaSuccessfull :null,
                IsNetsisSuccessfull :null,
                IsPaymentSuccessfull :null,
                PlasiyerId:null,
            },
            boolData:[
                {text:'Tümü',value:null},
                {text:'Evet',value:true},
                {text:'Hayır',value:false}
            ],
            salesman:[]
        }
    },
    mounted(){
        this.getSalesman()
    },
    methods:{
        getSalesman(){
            UserApi.SalesmanList().then(res=>{
                this.salesman = res.data.Data?.map(s=>{
                    return {
                        ...s,
                        Visual:`${s.FullName } - ${s.SalesPersonCode}`
                    }
                })
                this.salesman.unshift({Id:null,Visual:'Tümü',SalesPersonCode:null})
            })
        },
        clearForm(){
            this.filter.CreateTimeStart = null
            this.filter.CreateTimeEnd = null
            this.filter.IsCompleted = null
            this.filter.IsNetsisOzelHesapKapatmaSuccessfull = null
            this.filter.IsNetsisSuccessfull = null
            this.filter.IsPaymentSuccessfull = null
            this.filter.PlasiyerId = null
        }
    },
    computed:{
        date:{
            get:function(){
                return [this.filter.CreateTimeStart,this.filter.CreateTimeEnd].filter(d=>d != null)
            },
            set:function(val){
                this.filter.CreateTimeStart = val[0] || null
                this.filter.CreateTimeEnd = val[1] || null
            }
        },
        sm:{
            get:function(){
                return this.salesman.find(r=>r.Id == this.filter?.PlasiyerId)
            },
            set:function(value){
                this.filter.PlasiyerId = value?.Id || null
            }
        }
    }
}
</script>

<style>

</style>